import "./statusHeader.css";
import { GetImages } from "../../../../utils/GetImages";
import dropdownIcon from "../../../../assets/componentsIcons/dropdown/dropdown.svg"; // adjust path
import ActionMenu from "../../../../newComponents/actionMenus/action-menu";
import SimpleButton from "../../../../newComponents/buttons/Simple-button";

const commonConfig = {
  title: "Application Submitted",
  description:
    "Application submitted verify your application and approve reject accordingly",
  actions: [
    { label: "Reject", type: "red bg-white border-danger", isDestructive: true },
    { label: "Approve", type: "white" },
  ],
  useDropdown: false,
};

export const tenantLeaseStatusConfig = {
   inprogress: {
    title: "Application Filled",
    description: "Please review your application and sign it",
    actions: [
      { label: "Download Application", type: "bg-white blue fw-600" },
      { label: "Sign Application", type: "White" },
    ],
    useDropdown: false,
  },
  withdraw: {
    title: "Application Withdrawn",
    description: "Your application has been withdrawn",
    actions: [],
    useDropdown: false,
  },
  submitted: {
    title: "Application Submitted",
    description: "Please wait while landlord starts reviewing your application",
    actions: [
       {
        label: "Withdraw Application",
        icon: GetImages.Withdraw,
        action: "withdraw",
        isDestructive: true,
      },
       { isDivider: true }, 
      {
        label: "Download Application",
        icon: GetImages.downloadIcon,
        action: "Download Application",
      },
     
    ],
    useDropdown: true,
  },
  feeNotSettled: {
    title: "Application Fee Not Settled",
    description: "Your landlord has not settled your application fee",
    actions: [],
    useDropdown: false,
  },
  close: {
    title: "Application Closed",
    description: "The landlord has closed your application",
    actions: [],
    useDropdown: false,
  },
  tenantSignaturePending: {
    title: "Your Signature Pending",
    description:
      "Your signature is pending to complete the agreement and finalize the tenant move-in process",
    actions: [{ label: "Sign Agreement", type: "primary" }],
    useDropdown: false,
  },
  agreementPaymentPending:{
    title: "Agreement Fee Not Settled",
    description: "Your landlord has not settled your Agreement fee",
    actions: [],
    useDropdown: false,
  },
  signed: {
    title: "Move In is in Progress",
    description:
      "Landlord started move in process",
    actions: [{ label: "View Agreement", type: "white" }],
    useDropdown: false,
  },
  landlordSignaturePending:{
     title: "Landlord Signature Pending",
    description:
      "Please wait while landlord signature your agreement",
    actions: [{ label: "View Agreement", type: "white" }],
    useDropdown: false,
  },
  renew: {
    title: "Lease Renewal in Progress",
    description: "Your lease renewal is in progress click on view agreement to continue your process.",
    actions: [{ label: "View Agreement", type: "blue" }],
    useDropdown: false,
  }

};

// ✅ New landlord side config
export const landlordLeaseStatusConfig = {
  inProgress: {
    title: "Application is in Progress",
    description:
      "Tenant is filling the lease application. Once the application is submitted, settle the application fee and proceed",
    actions: [{ label: "Send Reminder", type: "" }],
    useDropdown: false,
  },
  paymentPending: {
    title: "Application is in Progress",
    description:
      "Tenant is filling the lease application. Once the application is submitted, settle the application fee and proceed",
    actions: [{ label: "Post Payment", type: "" }],
    useDropdown: false,
  },
  submitted: commonConfig,
  review: {
  title: "Application is in Progress",
  description:
    "Application submitted verify your application and approve reject accordingly",
  actions: [
    { label: "Reject", type: "red bg-white border-danger", isDestructive: true },
    { label: "Approve", type: "white" },
  ],
  useDropdown: false,
},
  tenantSignaturePending: {
    title: "Tenant Signature Pending",
    description:
      "The tenant has not signed the document yet; please send a reminder for their signature.",
    actions: [{ label: "Send Reminder", type: "" }],
    useDropdown: false,
  },
  landlordSignaturePending: {
    title: "Your Signature Pending",
    description:
      "Your signature is pending to complete the agreement and finalize the tenant move-in process",
    actions: [{ label: "Sign Agreement", type: "" }],
    useDropdown: false,
  },
  agreementSigned: {
    title: "Agreement Signed By Tenant",
    description:
      "The tenant has signed the agreement, and the next step is to proceed with settling the payment.",
    actions: [{ label: "Post Payment", type: "" }],
    useDropdown: false,
  },

  leasePaymentPending: {
    title: "Lease Agreement Payment Pending",
    description:"The lease agreement has been signed, please post the payment to proceed.",
    actions: [{ label: "Post Payment", type: "" }],
    useDropdown: false,
  },
  moveInProgress: {
    title: "Move In is in Progress",
    description: "Complete Move In",
    actions: [],
    useDropdown: false,
  },
   close: {
    title: "Application Close",
    description: "Landlord close the application",
    actions: [],
    useDropdown: false,
  },
   Reject: {
    title: "Application Rejected",
    description: "Landlord has rejected the application",
    actions: [],
    useDropdown: false,
  },
renew:{
   title: "Lease Renewal in Progress",
   description: "Your lease renewal is in progress click on view details to continue your process.",
   actions: [{ label: "View", type: "" }],
   useDropdown: false,
},
movein:{
   title: "Move In is in Progress",
    description: "Complete Move In",
      actions: [],
    useDropdown: false,
},
moveout:{
   title: "Move Out is in Progress",
    description: "Your move out process is in progress click button to continue process",
      actions: [{ label: "View", type: "" }],
    useDropdown: false,
}

  

};

const getButtonClass = (label: string) => {
  if (label === "Reject") return "btn-outline-red";
  if (label === "Download Application" || label ==="View Agreement") return "btn-outline-blue";
  return "btn-regular";
};
const StatusHeader = ({ status, onActionClick, role = "tenant", disableApprove = false }) => {
  const config =
    role === "landlord"
      ? landlordLeaseStatusConfig[status]
      : tenantLeaseStatusConfig[status];

  if (!config) return null;

  if (!config) return null;

  return (
    <div className={`status-header ${status == "withdraw" || status == "Reject" || status == "close" ? "BackgroundlightRed" : "BackgroundlightBlue"}`}>
      <div className="status-info">
        <div className={` ${status == "withdraw" || status == "Reject" || status == "close" ? "BackgroundRed" : "BackgroundBlue"} Icon40  CommonRoundBackgroundNoSize`}>
          <img className="color-white-icon" alt="basicdeatils-doc" src={status == "withdraw" || status == "Reject" || status == "close" ? GetImages.infoRedIcon : GetImages.InfoIcon} />
        </div>
        <div>
          <p className='heading'>{config.title}</p>
          <p className="normal_text">{config.description}</p>
        </div>
      </div>

      <div className="status-actions">
        {config.useDropdown ? (
          <ActionMenu
            menuItems={config.actions.map((a) => ({
              icon: a.icon,
              label: a.label,
              action: () => onActionClick(a.action), // pass action type
              isDivider: a.isDivider,
              isDestructive: a.isDestructive,
            }))}
            trigger={
              <button className="action-button">
                <img
                  src={dropdownIcon}
                  alt="More options"
                  width={20}
                  height={20}
                  className="action-icon"
                />
              </button>
            }
          />
        ) : ( config?.actions?.map((action, idx) => (
            <SimpleButton
             onClick={() => onActionClick(action.label)}
            className={getButtonClass(action.label)}
            isDisabled={action.label === "Approve" && disableApprove}
            label={action.label}
            type="submit"
            />
           
          ))
        )}
      </div>
    </div>
  );
};

export default StatusHeader;

